<div class="container">
  <div class="discovers" (scroll)="discoversScroll($event)" *ngIf="!isMobile || !mapDisplayed"
    [class.marginMobile]="isMobile">
    <div class="admin-btn" *ngIf="isAdmin">
      <button class="wire-btn skalaki" (click)="editDiscoverModal()">
        Add a new place
      </button>
    </div>
    <div class="discover-text" id="discover1" (click)="updateText(discover1, updateTextTemplate)"
      [innerHTML]="discover1.text">
    </div>
    <div *ngFor="let discover of discovers" class="discover-card" (click)="selectDiscover(discover)">
      <div class="discover-picture-container">
        <img [src]="discover.picture.path" alt="image" *ngIf="discover.picture" [hidden]="!discover.picture.loaded"
          (load)="discover.picture.loaded=true">
        <img src="../../assets/loading.gif" alt="Card image cap" *ngIf="discover.picture && !discover.picture.loaded">
      </div>
      <div class="discover" [class.mobile]="isTablet || isMobile">
        <div class="discover-title">{{getDiscoverNumber(discover)}} {{getDiscoverTitle(discover)}}
        </div>
        <span class="discover-description">
          <p #discoverCard [innerHTML]="getDiscoverProperty(discover, 'description')"></p>
        </span>
      </div>
    </div>
    <div class="up-button" [class.has-scroll]="hasScroll">
      <button class="wire-btn filled" (click)="scrollTop()">{{'Vers le haut' | translate}}<i
          class="fa fa-arrow-up"></i></button>
    </div>
  </div>
  <div class="map" *ngIf="!isMobile || mapDisplayed" [class.marginMobile]="isMobile">
    <iframe *ngIf="this.translate.currentLang === 'fr'" allow="geolocation" id='frameFr' class="map-frame"
      title="frameFr" allowfullscreen
      src="https://umap.openstreetmap.fr/fr/map/crete-de-lest_308392?scaleControl=true&miniMap=false&scrollWheelZoom=false&zoomControl=true&allowEdit=false&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=null&onLoadPanel=undefined&captionBar=false&datalayers=813223&fullscreenControl=true&measureControl=false&editinosmControl=false">
    </iframe>
    <iframe *ngIf="this.translate.currentLang === 'en'" allow="geolocation" id='frameEn' class="map-frame"
      title="frameEn" allowfullscreen
      src="https://umap.openstreetmap.fr/fr/map/eastern-crete_315002?scaleControl=true&miniMap=false&scrollWheelZoom=false&zoomControl=true&allowEdit=false&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=null&onLoadPanel=undefined&captionBar=false&datalayers=832271&fullscreenControl=true&measureControl=false&editinosmControl=false">
    </iframe>
  </div>
</div>

<div class="map-nav" *ngIf="isMobile">
  <div (click)="displayMap(false)" [class.map-nav-selected]="!mapDisplayed">
    {{'Liste' | translate}}
  </div>
  <div (click)="displayMap(true)" [class.map-nav-selected]="mapDisplayed">
    {{'Carte' | translate}}
  </div>
</div>

<ng-template #updateTextTemplate>
  <div class="modal-content">
    <div class="header">
      Update text
      <div class="close" (click)="modalRef.hide()">
        <i class="fa fa-times"></i>
      </div>
    </div>
    <div class="content">
      <textarea rows="25" [(ngModel)]="textModel.text"></textarea>
    </div>
    <div class="footer">
      <button class="wire-btn" (click)="saveText()">Save</button>
      <button class="wire-btn default" (click)="modalRef.hide()">Cancel</button>
    </div>
  </div>
</ng-template>